export const maxLength = (value, max) => {
    if (value.length > max) {
        return `Не может быть длиннее ${max} символов`;
    }
    return null;
};
